import React from 'react';
import { Checkbox, Tooltip } from 'antd';
import styles from './CheckboxFilterList.module.scss';

export interface CheckboxFilterListOption {
  label: string;
  value: string;
}

export interface CheckboxFilterListProps {
  options: CheckboxFilterListOption[];
  selectedValues: string[];
  onChange: (values: string[]) => void;
}

export const CheckboxFilterList: React.FC<CheckboxFilterListProps> = ({ options, selectedValues, onChange }) => {
  const handleToggle = (value: string) => {
    const isSelected = selectedValues.includes(value);
    const next = isSelected ? selectedValues.filter((v) => v !== value) : [...selectedValues, value];
    onChange(next);
  };

  return (
    <div className={styles.list}>
      {options.map((opt) => {
        const isSelected = selectedValues.includes(opt.value);
        return (
          <div key={opt.value} className={styles.item}>
            <span className={styles.label}>
              <Tooltip title={opt.label} placement="topLeft" mouseEnterDelay={0.7} arrow={false}>
                <span className={styles.labelText}>{opt.label}</span>
              </Tooltip>
            </span>
            <Checkbox
              checked={isSelected}
              onChange={() => handleToggle(opt.value)}
              onClick={(e) => e.stopPropagation()}
              className={styles.checkbox}
            />
          </div>
        );
      })}
    </div>
  );
};
